// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "./Box.res.js";
import * as Stack from "./Stack.res.js";
import * as Title from "../typography/Title.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Tooltip from "../overlays/Tooltip.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let Action = {};
let styles = {
  container: {
    "backgroundColor-kWkggS": "backgroundColor-x17suf5r",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "minWidth-k7Eaqz": "minWidth-xeuugli",
    "paddingBlock-k8WAf4": "paddingBlock-x10dr8xq",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/layout-and-structure/Card.res.js:15"
  },
  grow: {
    "flex-kUk6DE": "flex-x98rzlu",
    $$css: "wino-gc:src/resources/layout-and-structure/Card.res.js:24"
  },
  shadow: {
    "boxShadow-kGVxlE": "boxShadow-xvh7wfu",
    $$css: "wino-gc:src/resources/layout-and-structure/Card.res.js:27"
  },
  title: {
    "display-k1xSpc": "display-x78zum5",
    "justifyContent-kjj79g": "justifyContent-x1qughib",
    "paddingRight-kpe85a": "paddingRight-x179gruy",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/layout-and-structure/Card.res.js:30"
  },
  title_action: {
    "position-kVAEAm": "position-x10l6tqk",
    "right-kCIrl2": "right-xn24pvi",
    "top-k87sOh": "top-x1fur4o1",
    $$css: "wino-gc:src/resources/layout-and-structure/Card.res.js:36"
  },
  centerContent: {
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    $$css: "wino-gc:src/resources/layout-and-structure/Card.res.js:41"
  }
};
function styleProps(shadowed, grow, centerContent) {
  return {
    0: {
      className: "backgroundColor-x17suf5r borderRadius-x1sxf85j display-x78zum5 flexDirection-xdt5ytf minWidth-xeuugli paddingBlock-x10dr8xq position-x1n2onr6",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:15"
    },
    4: {
      className: "backgroundColor-x17suf5r borderRadius-x1sxf85j display-x78zum5 flexDirection-xdt5ytf minWidth-xeuugli paddingBlock-x10dr8xq position-x1n2onr6 boxShadow-xvh7wfu",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:15; wino-gc:src/resources/layout-and-structure/Card.res.js:27"
    },
    2: {
      className: "backgroundColor-x17suf5r borderRadius-x1sxf85j display-x78zum5 flexDirection-xdt5ytf minWidth-xeuugli paddingBlock-x10dr8xq position-x1n2onr6 flex-x98rzlu",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:15; wino-gc:src/resources/layout-and-structure/Card.res.js:24"
    },
    6: {
      className: "backgroundColor-x17suf5r borderRadius-x1sxf85j display-x78zum5 flexDirection-xdt5ytf minWidth-xeuugli paddingBlock-x10dr8xq position-x1n2onr6 boxShadow-xvh7wfu flex-x98rzlu",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:15; wino-gc:src/resources/layout-and-structure/Card.res.js:27; wino-gc:src/resources/layout-and-structure/Card.res.js:24"
    },
    1: {
      className: "backgroundColor-x17suf5r borderRadius-x1sxf85j display-x78zum5 flexDirection-xdt5ytf minWidth-xeuugli paddingBlock-x10dr8xq position-x1n2onr6 justifyContent-xl56j7k",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:15; wino-gc:src/resources/layout-and-structure/Card.res.js:41"
    },
    5: {
      className: "backgroundColor-x17suf5r borderRadius-x1sxf85j display-x78zum5 flexDirection-xdt5ytf minWidth-xeuugli paddingBlock-x10dr8xq position-x1n2onr6 boxShadow-xvh7wfu justifyContent-xl56j7k",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:15; wino-gc:src/resources/layout-and-structure/Card.res.js:27; wino-gc:src/resources/layout-and-structure/Card.res.js:41"
    },
    3: {
      className: "backgroundColor-x17suf5r borderRadius-x1sxf85j display-x78zum5 flexDirection-xdt5ytf minWidth-xeuugli paddingBlock-x10dr8xq position-x1n2onr6 flex-x98rzlu justifyContent-xl56j7k",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:15; wino-gc:src/resources/layout-and-structure/Card.res.js:24; wino-gc:src/resources/layout-and-structure/Card.res.js:41"
    },
    7: {
      className: "backgroundColor-x17suf5r borderRadius-x1sxf85j display-x78zum5 flexDirection-xdt5ytf minWidth-xeuugli paddingBlock-x10dr8xq position-x1n2onr6 boxShadow-xvh7wfu flex-x98rzlu justifyContent-xl56j7k",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:15; wino-gc:src/resources/layout-and-structure/Card.res.js:27; wino-gc:src/resources/layout-and-structure/Card.res.js:24; wino-gc:src/resources/layout-and-structure/Card.res.js:41"
    }
  }[!!shadowed << 2 | !!grow << 1 | !!centerContent << 0];
}
function Card(props) {
  let __centerContent = props.centerContent;
  let __grow = props.grow;
  let __shadowed = props.shadowed;
  let __variation = props.variation;
  let action = props.action;
  let title = props.title;
  let children = props.children;
  let variation = __variation !== undefined ? __variation : "common";
  let shadowed = __shadowed !== undefined ? __shadowed : false;
  let grow = __grow !== undefined ? __grow : false;
  let centerContent = __centerContent !== undefined ? __centerContent : false;
  let actionButton;
  if (action !== undefined) {
    let newrecord = {
      ...{
        className: "position-x10l6tqk right-xn24pvi top-x1fur4o1",
        "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:36"
      }
    };
    actionButton = JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsx(Button.make, {
        variant: "subtle",
        icon: action.icon,
        href: action.href,
        target: action.target,
        onPress: action.onPress
      }),
      placement: "top",
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: action.title
      }),
      delay: 350,
      closeDelay: 0
    }), newrecord));
  } else {
    actionButton = null;
  }
  let newrecord$1 = {
    ...styleProps(shadowed, grow, centerContent)
  };
  let tmp;
  if (variation === "table") {
    let tmp$1;
    if (title !== undefined) {
      let newrecord$2 = {
        ...{
          className: "display-x78zum5 justifyContent-x1qughib paddingRight-x179gruy position-x1n2onr6",
          "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:30"
        }
      };
      tmp$1 = JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs("div", (newrecord$2.children = [JsxRuntime.jsx(Title.make, {
          children: title,
          level: 3,
          weight: "semibold"
        }), actionButton], newrecord$2)),
        spaceX: "large",
        spaceBottom: "xnormal"
      });
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsxs(Box.make, {
      children: [tmp$1, JsxRuntime.jsx(Stack.make, {
        children: children,
        space: "none"
      })],
      spaceY: "medium",
      spaceTop: "small",
      spaceBottom: "medium"
    });
  } else if (variation === "unset") {
    let tmp$2;
    if (title !== undefined) {
      let newrecord$3 = {
        ...{
          className: "display-x78zum5 justifyContent-x1qughib paddingRight-x179gruy position-x1n2onr6",
          "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:30"
        }
      };
      tmp$2 = JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs("div", (newrecord$3.children = [JsxRuntime.jsx(Title.make, {
          children: title,
          level: 3,
          weight: "semibold"
        }), actionButton], newrecord$3)),
        spaceBottom: "medium"
      });
    } else {
      tmp$2 = null;
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [tmp$2, JsxRuntime.jsx(Stack.make, {
        children: children,
        space: "xlarge"
      })]
    });
  } else {
    let tmp$3;
    if (title !== undefined) {
      let newrecord$4 = {
        ...{
          className: "display-x78zum5 justifyContent-x1qughib paddingRight-x179gruy position-x1n2onr6",
          "data-style-src": "wino-gc:src/resources/layout-and-structure/Card.res.js:30"
        }
      };
      tmp$3 = JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs("div", (newrecord$4.children = [JsxRuntime.jsx(Title.make, {
          children: title,
          level: 3,
          weight: "semibold"
        }), actionButton], newrecord$4)),
        spaceBottom: "large"
      });
    } else {
      tmp$3 = null;
    }
    tmp = JsxRuntime.jsxs(Box.make, {
      children: [tmp$3, JsxRuntime.jsx(Stack.make, {
        children: children,
        space: "xlarge"
      })],
      spaceX: "large",
      spaceTop: "small",
      spaceBottom: "medium"
    });
  }
  newrecord$1.children = tmp;
  return JsxRuntime.jsx("div", newrecord$1);
}
let make = React.memo(Card);
make.displayName = "Card";
let variationCommon = "common";
export { variationCommon, Action, styles, styleProps, make };
/* styles Not a pure module */